import { useState } from "react";
import { DropOff } from "type/addressType";

export function DropoffDropDown({
  dropdown,
  setDropId,
}: {
  dropdown: DropOff[];
  setDropId: React.Dispatch<React.SetStateAction<number>>;
}): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Select location");

  const toggleDropdown = () => setIsOpen(!isOpen);
  const handleOptionClick = (option: string, id: number) => {
    setSelectedOption(option);
    setDropId((prev: any) => ({
      ...prev,
      dropOffId: id || null,
    }));
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block w-full">
      <div
        className="mt-2  w-full p-4 border-2 border-inputBorderGreen bg-white text-gray-500 font-semibold rounded-md cursor-pointer flex items-center justify-between"
        onClick={toggleDropdown}>
        {selectedOption}{" "}
        <figure>
          <img
            src="/images/chevronDown.svg"
            alt="drop-down"
            className="mt-0.5 pr-2 cursor-pointer"
          />
        </figure>
      </div>
      {isOpen && (
        <ul className="absolute z-10 mt-1 w-full flex flex-col items-stretch gap-3 bg-white border border-gray-300 rounded-xl shadow-lg px-4 pt-2">
          {dropdown?.map((dropItem: DropOff) => (
            <li
              className="cursor-pointer pb-2 border-b-2 border-gray-200 flex flex-col items-start gap-2"
              onClick={() => handleOptionClick(dropItem.address, dropItem.id)}
              key={dropItem.id}>
              <div className="flex items-center gap-2">
                <span className="text-sm">
                  {dropItem.address.split(",")[0]?.length < 6
                    ? dropItem.address.split(",")[1]
                    : dropItem.address.split(",")[0]}
                </span>
                <span className="flex items-center gap-1">
                  <img src="/images/transport.svg" alt="transport icon" />
                  <p className="text-xs text-green-600">
                    {dropItem.distance.toString().split(".")[0]}
                  </p>
                </span>
              </div>
              <p className="text-sm">{dropItem.address}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
